/**
 * dealFormat.ts
 *
 * Single source of truth for formatting a deal's numeric value.
 * A $2-off deal is NOT a $2 price — rendering it as "$2" (the old
 * behavior, which always assumed price) told users the beer costs $2
 * when it just means $2 cheaper than usual. Falls back to 'price' for
 * any deal that predates value_type (existing DB rows have no
 * value_type key at all).
 *
 * This used to be copy-pasted identically into 6 files
 * (BestPicksRow, VenueCard, VenuePopup, BrowsePage, TonightPage,
 * VenueDetailPage). It was still in sync everywhere as of this fix,
 * but there's no guarantee the next edit stays that way if it's
 * touched in only one place under time pressure — import from here
 * instead of redefining it.
 */
export interface DealValueShape {
  price?: number | null
  value?: number | null
  value_type?: string | null
}

export function fmtDealValue(d: DealValueShape): string | null {
  const vt = d.value_type === 'amount_off' || d.value_type === 'percent_off' ? d.value_type : 'price'
  const val = vt === 'price' ? (d.price ?? d.value) : d.value
  if (val == null) return null
  if (vt === 'amount_off') return `$${val} off`
  if (vt === 'percent_off') return `${val}% off`
  return `$${val}`
}
